import { OptionProps } from 'pages/ChartEditorPage/meta/CustomizeOptions';
import { filteredBy, annotationsList } from './highed.annotations.utils';

const option: OptionProps = {
  id: 'annotation.text.lines',
  pid: 'annotation.text.lines',
  defaultFilterValue: ['line'],
  subType: annotationsList,
  filteredBy: filteredBy,
  options: [
    {
      pid: 'label.type',
      type: 'select',
      id: 'markerEnd',
      default: 'line',
      values: [
        { label: 'Line', value: 'line' },
        { label: 'Arrow', value: 'arrow' }
      ]
    },
    {
      pid: 'label.size',
      id: 'strokeWidth',
      type: 'number',
      default: 1
    },
    {
      pid: 'line.color',
      type: 'color',
      id: 'stroke',
      default: '#404040'
    }
  ]
};

export default option;
